import { render, staticRenderFns } from "./Quickpayment.vue?vue&type=template&id=6458a8ac"
import script from "./Quickpayment.vue?vue&type=script&lang=js"
export * from "./Quickpayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports